var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTittleZone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5467 14.332V2.33203C13.5467 1.7787 13.1 1.33203 12.5467 1.33203H4.01333C3.74 1.33203 3.48667 1.44536 3.30667 1.62536C3.12667 1.80536 3.01333 2.0587 3.01333 2.33203V14.332H2V15.332H14.56V14.332H13.5467ZM8.78 14.332V12.1587H7.78V14.332H4.01333V2.33203H12.54V14.332H8.77333H8.78Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03333 9.40536H6.03333V10.7387H7.03333V9.40536Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5267 9.40536H9.52667V10.7387H10.5267V9.40536Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03333 6.7187H6.03333V8.05203H7.03333V6.7187Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5267 6.7187H9.52667V8.05203H10.5267V6.7187Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03333 4.0387H6.03333V5.37203H7.03333V4.0387Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5267 4.0387H9.52667V5.37203H10.5267V4.0387Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTittleZone);
export default __webpack_public_path__ + "static/media/ic-tittle-zone.2c879d7d19bd012f73381db3f663d020.svg";
export { ForwardRef as ReactComponent };